module.exports = __webpack_public_path__ + "img/background404.2b268901.jpg";